import { TableCell, TableRow } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";

import { selectRemoteAccess } from "../../../model/RemoteMaintenance";
import { selector as authStoreSelector } from "../../../store/AuthStore";
import { selector as remoteMaintenanceStoreSelector } from "../../../store/RemoteMaintenanceStore";
import useStyles from "../useStyles";

import RemoteAccessDialog from "./RemoteAccessDialog";

/**
 * RemoteMaintenanceTableRowコンポーネント.
 *
 * @return {object} コンポーネント
 * @param  {function} onClick テーブル行クリック時の処理
 */
function RemoteMaintenanceTableRow() {
  // スタイル
  const styles = useStyles();

  // ダイアログの表示状態State (true: 表示 / false: 非表示)
  const [isOpenDialog, setIsOpenDialog] = React.useState(false);
  const [selectMachineInfo, setSelectMachineInfo] = React.useState({});

  const {
    // 機器情報一覧
    machineInfos,
  } = useSelector(remoteMaintenanceStoreSelector);

  const {
    // リモート保守ダイアログ表示フラグ（true: 表示、false: 非表示）
    isDisplayRemoteMaintenanceDialog,
  } = useSelector(authStoreSelector);

  // テーブル行クリック時の処理
  const handleTableRowClick = (machineInfo) => {
    const value = { ...machineInfo };
    if (value.clientIp === "-") {
      value.clientIp = "";
    }
    setSelectMachineInfo(value);
    // ダイアログOpen
    setIsOpenDialog(true);
  };

  // ダイアログClose時の処理
  const handleDialogClose = () => {
    setIsOpenDialog(false);
  };

  // 文字色判定(リモート設定、クライアントIP、有効期限)
  const checkRemoteColor = (machineRemoteAccess) => {
    const fontColor =
      selectRemoteAccess[
        selectRemoteAccess.findIndex(
          ({ value }) => value === machineRemoteAccess
        )
      ].stroke;
    return { color: fontColor };
  };

  const checkPowerColor = (machinePowerStatus) => {
    const fontColor = machinePowerStatus ? "lime" : "black";
    const Weight = machinePowerStatus ? "bold" : "normal";
    return { color: fontColor, fontWeight: Weight };
  };

  return !machineInfos || !machineInfos.length ? (
    <TableRow>
      <TableCell>-</TableCell>
      <TableCell>-</TableCell>
      <TableCell>-</TableCell>
      <TableCell>-</TableCell>
      <TableCell>-</TableCell>
      <TableCell>-</TableCell>
      <TableCell>-</TableCell>
    </TableRow>
  ) : (
    <>
      {machineInfos.map((machineInfo) => (
        <TableRow
          key={machineInfo.serialNumber}
          hover
          onClick={() => handleTableRowClick(machineInfo)}
        >
          <TableCell>
            <div className={styles.flexStart}>
              <div className={`${styles.machineNameText} ${styles.wordBreak}`}>
                {machineInfo.iotName}
              </div>
            </div>
          </TableCell>
          <TableCell>
            {machineInfo.serialNumber}-{machineInfo.label}
          </TableCell>
          <TableCell style={checkPowerColor(machineInfo.power)}>
            {machineInfo.power ? "Power On" : "Power Off"}
          </TableCell>
          <TableCell style={checkRemoteColor(machineInfo.remoteAccess)}>
            {
              selectRemoteAccess[
                selectRemoteAccess.findIndex(
                  ({ value }) => value === machineInfo.remoteAccess
                )
              ].label
            }
          </TableCell>
          <TableCell style={checkRemoteColor(machineInfo.remoteAccess)}>
            {machineInfo.remoteAccess ? `${machineInfo.enableTime}時間` : "-"}
          </TableCell>
          <TableCell style={checkRemoteColor(machineInfo.remoteAccess)}>
            {machineInfo.remoteAccess ? machineInfo.clientIp : "-"}
          </TableCell>
          <TableCell>{machineInfo.power ? machineInfo.boxIp : "-"}</TableCell>
        </TableRow>
      ))}
      {isDisplayRemoteMaintenanceDialog && selectMachineInfo.serialNumber && (
        <RemoteAccessDialog
          open={isOpenDialog}
          machineInfo={selectMachineInfo}
          onClose={handleDialogClose}
        />
      )}
    </>
  );
}

export default RemoteMaintenanceTableRow;
